import {Component} from '@angular/core';
import {MerchantService} from '../../../core/services/merchant.service';
import {MerchantStore} from '../../../core/stores/merchant.store';
import {Router} from '@angular/router';
import {RestaurantStore} from '../../../core/stores/restaurant.store';
import {StorageService} from '../../../core/services/storage.service';
import {Merchant} from '../../../core/models/restaurant.model';

@Component({
  selector: 'app-find-merchant',
  templateUrl: './find-merchant.component.html',
  styleUrls: ['./find-merchant.component.scss'],
})
export class FindMerchantComponent {

  public vanityLink: string;
  public isLoading: boolean;
  public hasError: boolean;

  constructor(private merchantStore: MerchantStore,
              private restaurantStore: RestaurantStore,
              private merchantService: MerchantService,
              private storageService: StorageService,
              private router: Router) {
  }

  public chooseMerchant(vanityLink: string): void {
    this.isLoading = true;
    this.merchantService.getMerchantByVanityLink(vanityLink).subscribe(({merchantId}: Merchant) => {
      this.isLoading = false;
      this.hasError = false;
      this.router.navigate(['merchants', merchantId]).catch((e) => console.error(e));
    }, () => {
      this.isLoading = false;
      this.hasError = true;
    });
  }
}
